import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { CountdownTimer } from './CountdownTimer';
export function BonusSection() {
  return <section className="py-24 px-4 bg-cream" data-id="element-17" data-mp="22elkura6lhjv">
      <div className="max-w-5xl mx-auto" data-id="element-18" data-mp="22dai8ush2fuc">
        <div className="text-center mb-16" data-id="element-19" data-mp="1ydrza4k7oeu5">
          <p className="text-terracotta font-semibold tracking-[0.18em] uppercase text-xs mb-2" data-id="element-20" data-mp="1ybxb8hdn86lu">
            Included at No Extra Cost
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-charcoal mb-4" data-id="element-21" data-mp="15q5itvpvxfpv">
            The 5 Strategic Bonuses
          </h2>
          <p className="text-charcoal-soft max-w-2xl mx-auto" data-id="element-22" data-mp="1ji27fpsch7hi">
            Every bonus is included to make your teaching week lighter, clearer,
            and better organized.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-23" data-mp="qyn9ggrj6jfh">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-paper border border-warmgray rounded-2xl p-8 relative flex flex-col h-full" data-id="element-24" data-mp="mws7rb5ou416" data-mpi={index}>
              <div className={`absolute top-0 right-0 px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-xs uppercase tracking-wider ${bonus.badgeClass}`} data-id="element-25" data-mp="1vuegg3enwc4j">
                Bonus {bonus.id}
              </div>

              <div className="w-12 h-12 bg-sand rounded-full flex items-center justify-center text-terracotta mb-6" data-id="element-26" data-mp="3c73b1a4eylyk">
                <Gift size={22} aria-hidden="true" data-id="element-27" data-mp="3h4ln39dq9has" />
              </div>

              <h3 className="text-xl font-serif font-bold mb-3 pr-20 text-charcoal" data-id="element-28" data-mp="1h35cu2rc340h">
                {bonus.title}
              </h3>

              <div className="inline-flex flex-wrap items-baseline gap-x-2 bg-sand border border-warmgray px-3 py-1 rounded mb-4 self-start" data-id="element-29" data-mp="1c3ix9mo19boi">
                <span className="text-charcoal-muted text-sm" data-id="element-30" data-mp="1q1qxq4ka2v4f">
                  Real value:{' '}
                  <span className="line-through" data-id="element-31" data-mp="1m0nhhgybix2o">${bonus.value}</span>
                </span>
                <span className="text-burnt font-bold" data-id="element-32" data-mp="yajgzigffdfw">→ FREE</span>
              </div>

              <p className="text-charcoal-soft text-sm mb-4 leading-relaxed" data-id="element-33" data-mp="tbq33ox89kf7">
                {bonus.desc}
              </p>

              <div className="mb-6 flex-grow" data-id="element-34" data-mp="12eisfmmunm2e">
                <p className="text-xs font-bold uppercase tracking-wider text-terracotta-dark mb-2" data-id="element-35" data-mp="12dpmuozmn2lu">
                  {bonus.itemsLabel}
                </p>
                <ul className="flex flex-wrap gap-1.5" data-id="element-36" data-mp="anl22p7ygdk3">
                  {bonus.items.map(item => <li key={item} className="bg-sand border border-warmgray text-charcoal-soft text-xs rounded-full px-2.5 py-1" data-id="element-37" data-mp="iuzch4q95et">
                      {item}
                    </li>)}
                </ul>
              </div>

              <p className="text-terracotta-dark text-sm italic font-medium mt-auto" data-id="element-38" data-mp="3rowf32zn0n6s">
                {bonus.benefit}
              </p>
            </motion.article>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-sand border border-terracotta/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-39" data-mp="o9iijyk3fhgo">
          <p className="text-charcoal-soft mb-2" data-id="element-40" data-mp="2yyxm4wibo5wu">
            Total Value of All 5 Bonuses
          </p>
          <p className="text-2xl text-charcoal-muted line-through mb-4" data-id="element-41" data-mp="3f9zq6tz60pvr">
            $63.00
          </p>
          <p className="text-lg text-charcoal mb-2" data-id="element-42" data-mp="35id585x0zcft">Your Price Today</p>
          <p className="text-5xl font-bold text-burnt mb-4" data-id="element-43" data-mp="35imutse5rhkz">FREE</p>
          <p className="text-sm text-terracotta-dark" data-id="element-44" data-mp="30kbklgjyb528">
            Included only with this offer.
          </p>
        </motion.div>

        <CountdownTimer data-id="element-45" data-mp="20v6qp357hs2" />
      </div>
    </section>;
}